import { render } from "./medicinePulInstructions.vue?vue&type=template&id=3c2cdd77&scoped=true"
import script from "./medicinePulInstructions.vue?vue&type=script&lang=js"
export * from "./medicinePulInstructions.vue?vue&type=script&lang=js"

import "./medicinePulInstructions.vue?vue&type=style&index=0&id=3c2cdd77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2cdd77"]])

export default __exports__